import ApiService from "@/common/api/base.service";

export const updateDestinationStoreLocation = {
  updateDestinationStoreLocation({ commit }, payload) {
    const response = ApiService.post("stores/update-inventory-location", { ...payload });
    return response;
  }
};
